<script>
import { deliveryStatusDotColor } from '@/services/Deliveries/JobStatus'

export default {
    props: {
        item: null,
        deliveries: Boolean,
    },
    computed: {
        isDeliveryProcessed() {
            return (
                (this.item?.isDeliveryProcessed && !this.deliveries) ||
                this.deliveries
            )
        },
        deliveryJob() {
            return this.item?.deliveryJob
        },
        updatedAt() {
            return this.deliveryJob?.updatedAt
        },
        status() {
            if (this.deliveries) {
                return this.item?.status
            } else {
                if (this.deliveryJob?.status === 'in_progress') {
                    if (this.deliveryJob?.courierStatus)
                        return this.deliveryJob.courierStatus
                    else return 'searching'
                } else return this.deliveryJob?.status
            }
        },
        isCloudCanteen() {
            return !!this.item.cloudcanteen
        },
        isResidentialCanteen() {
            return !!this.item.residentialcanteen
        },
        isRestaurantManaged() {
            return (
                (!this.deliveryJob ||
                    this.deliveryJob.primaryMethod === 'restaurant_managed') &&
                this.isDeliveryProcessed &&
                !this.deliveries //page
            )
        },
        hasError() {
            return this.deliveries
                ? this.status === 'error'
                : Boolean(
                      this.deliveryJob?.latestCourierError ||
                          this.deliveryJob?.latestCourierErrorDeliveryMethod
                  )
        },
        CError() {
            return this.deliveryJob?.latestCourierError && !this.deliveries
                ? `${this.deliveryJob?.latestCourierError}`
                : ''
        },
        CDMError() {
            return this.deliveryJob?.latestCourierErrorDeliveryMethod &&
                !this.deliveries
                ? `[${this.deliveryJob?.latestCourierErrorDeliveryMethod}] `
                : ''
        },
        errorMessage() {
            return this.deliveries
                ? this.item.error
                : this.CDMError.concat(this.CError)
        },
        dotColor() {
            return deliveryStatusDotColor(this.status)
        },
        // the order's status as its name (the list sends the number or the name)
        orderStatus() {
            const status = this.item?.status
            const names = {
                0: 'init-payment',
                1: 'new',
                2: 'approved',
                3: 'cancelled',
                4: 'cancelled-after-approval',
            }
            return names[status] ?? status
        },
        // no courier job and none will come: a cancelled or unpaid order is never processed (core-api creates a job
        // only for a paid new / confirmed order), so "Under process..." would mislead (tasks#211)
        noJobReason() {
            if (this.deliveries || this.deliveryJob || this.isDeliveryProcessed)
                return null
            if (
                ['cancelled', 'cancelled-after-approval'].includes(
                    this.orderStatus
                )
            ) {
                return this.tr(
                    'delivery_job_status.no_job_cancelled',
                    'No delivery · order cancelled'
                )
            }
            if (this.orderStatus === 'init-payment') {
                return this.tr(
                    'delivery_job_status.no_job_unpaid',
                    'Waiting for payment'
                )
            }
            return null
        },
        needDriverInfo() {
            return (
                this.deliveryJob &&
                this.deliveryJob.driverInfo &&
                ['queued', 'searching'].indexOf(this.status) > -1
            )
        },
    },
    methods: {
        tr(key, fallback) {
            return this.$te(key) ? this.$t(key) : fallback
        },
    },
}
</script>

<template lang="pug">
span(v-if="isRestaurantManaged")
    template(v-if="isCloudCanteen") {{ $t('labels.cloud_canteen') }}
    template(v-else-if="isResidentialCanteen") {{ $t('labels.residential_canteen') }}
    template(v-else) {{ $t('delivery_job_status.restaurant_managed') }}
v-tooltip(:disabled="!(hasError)" v-else-if="isDeliveryProcessed && status" bottom)
    template(v-slot:activator='{ on, attrs }')
        .d-inline-flex.align-center(v-bind='attrs' v-on='on' :class="{'c-default': ! hasError}")
            span.dd-status-dot(:style="{ backgroundColor: dotColor }")
            .d-flex.flex-column(v-if="deliveries")
                |  {{$t(`delivery_job_status.${status}`)}}
            .d-flex.flex-column(v-else)
                template(v-if="deliveryJob && deliveryJob.status === 'in_progress'")
                    | {{$t(`courier_status.${status}`)}}
                template(v-else)
                    |  {{$t(`delivery_job_status.${status}`)}}
                small.d-flex.flex-nowrap.g-73--text(v-if="deliveryJob && deliveryJob.activeDeliveryMethod") {{$t(`active_delivery_method.${deliveryJob.activeDeliveryMethod}`)}}
                small.g-73--text(v-if="needDriverInfo")
                    span.comma(v-for="(count, method) in deliveryJob.driverInfo")
                        span(v-if="count > 1") {{ count }}&nbsp;
                        span {{ $t(`enums.delivery_methods.${method}`) }}
                small.d-flex.flex-nowrap.g-73--text(v-if="updatedAt") {{ updatedAt | transformDate}}
    span(v-if="hasError") {{errorMessage}}
span.g-73--text(v-else-if="noJobReason") {{ noJobReason }}
span(v-else) {{ $t('delivery_job_status.under_process') }}

</template>
